import { ObjectUtil } from '@shared/utils/object.util';
import { environment } from 'src/environments/environment';

export const Icons = {
  delete: environment.RESOURCE_SERVER_URL + '/assets/images/Misc_Icons/Delete.svg',
  add: environment.RESOURCE_SERVER_URL + '/assets/images/Misc_Icons/Add.svg',
  add2: environment.RESOURCE_SERVER_URL + '/assets/images/Misc_Icons/Add2.svg',
  BenefitParameters: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/BenefitParameters.svg',
  back: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/Back.svg',
  back_white: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/Back White.svg',
  search: environment.RESOURCE_SERVER_URL + '/assets/images/Dashboard/search.svg',
  search_black: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/Search.svg',
  close: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/cancel 1.svg',
  policyTermination: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Policy_Termination.svg',
  policyCancellation: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Policy_Cancellation.svg',
  policyAlteration: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Policy_Alteration.svg',
  policyRenewal: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Policy_Renewal.svg',
  header_banner: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Header_Banner.png',
  quote: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Get Quote.svg',
  app_prss: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Application  Process.svg',
  copyProduct: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Copy.svg',
  addProduct: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Add.svg',
  delProduct: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Delete.svg',
  header_select_proposal: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Header.jpg',
  pru_corporate_life: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/PRUCorporate Life.png',
  pru_corporate_medical: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/PRUCorporate Medical.png',
  pru_corporate_pa: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/PRUCorporate Personal Accident.png',
  pru_work_life: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/PRUWorks Life.png',
  pru_work_medical: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/PRUWorks Medical.png',
  pru_work_pa: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/PRUWorks Personal Accident.png',
  cloud: environment.RESOURCE_SERVER_URL + '/assets/images/registration/cloud.svg',
  retrieve: environment.RESOURCE_SERVER_URL + '/assets/images/registration/retrieve.svg',
  dot: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/dots.svg',
  download: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/download.svg',
  threeDotIcon: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/dots.svg',
  sendIcon: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Send.svg',
  copyIcon: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Copy.svg',
  deleteIcon: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Delete.svg',
  logIcon: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Log.svg',
  cloneIcon: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Clone.svg',
  prev: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/prev.svg',
  next: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/next.svg',
  upload: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/Upload.svg',
  download_violet: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Premium Per Insured.svg',
  download_blue: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Premium Per Insured_blue.svg',
  filter: environment.RESOURCE_SERVER_URL + '/assets/images/Dashboard/Table/filter.svg',
  dragIndicator: environment.RESOURCE_SERVER_URL + '/assets/images/Dashboard/Table/drag_indicator.svg',
  collapse: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/collapse.svg',
  expand: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/expand.svg',
  upload_support_doc: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/upload_support_doc.svg',
  tick: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/Tick.svg',
  history: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/History.svg',
  sixDots: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/sixDots.svg',
  image: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Images.svg',
  view: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/View.svg',
  edit: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Edit.svg',
  uploadArrow: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/upload_black_24dp copy.svg',
  filePath: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/file_path_black.svg',
  proposeInfoIcon: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Propose_Information',
  productPlanIcon: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Products_and_Plans',
  benefitIcon: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Benefits',
  memberUploadIcon: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Member_Upload',
  premiumSummaryIconn: environment.RESOURCE_SERVER_URL + '/assets/images/Quote_and_apply/Premium_Summary',
  undo: environment.RESOURCE_SERVER_URL + '/assets/images/common_icons/Undo.svg',
};

export const DEFAULT_EMPTY_ERROR = 'Mandatory field(s) (*) must not be empty.';

export const DEFAULT_EMPTY_OPTION = { label: 'Choose an option', value: null };
export const DEFAULT_EMPTY_OTHER = { label: 'Other', value: 'OTHER' };

export const POPUP_MESSAGE_VARIABLE = 'V011';

export enum METHOD {
  GET = 'get',
  POST = 'post',
  DELETE = 'delete',
  PATCH = 'patch',
}

export enum CONTRACT_TYPE {
  GCL = 'GCL',
  GCP = 'GCP',
  GCM = 'GCM',
  GWL = 'GWL',
  GWP = 'GWP',
  GWM = 'GWM',
}
export enum INDO_VALUE {
  RI = 'RI',
  IDN = 'IDN',
  INDO = '312',
}

export enum DOCUMENT_STATUS {
  INVALID = 'InValid',
  VALID = 'Valid',
}

export enum SALE_STATUS {
  INCOMPLETE = 'INCOMPLETE',
  COMPLETE = 'COMPLETE',
}

export const PROPOSAL_VERSION_STATUS = {
  PRINTED: 'Printed',
  OPEN: 'Open',
  LOCKED: 'Locked',
  PENDING_UW_CHECKED: 'Pending UW Checked',
  PENDINGUWCHECKED: 'PendingUWCheck',
  PENDING_FOR_UW_CHECKED: 'Pending for UW Checked',
  TRANSFERRED: 'Transferred',
  RETURNED: 'Returned',
  PENDING_FOR_UW_ADJUSTMENT: 'Pending for UW Adjustment',
  PENDING_AT_SALES: 'Pending at Sales',
  EXPIRED: 'Expired',
  CONFIRMED: 'Confirmed',
  DECLINE: 'Decline',
  DECLINED: 'Declined',
};

export const PROPOSAL_STATUS = {
  PENDING_ISSUANCE: 'Pending Issuance',
  POLICY_INFORCE: 'Policy Inforce',
  NEGOTIATION: 'Negotiation',
};

export const PROPOSAL_STATUS_DISABLED = {
  PENDING_UW_CHECKED: 'Pending UW Checked',
  PENDING_FOR_UW_CHECKED: 'Pending for UW Checked',
  CLOSED: 'Closed',
  PENDING_ISSUANCE: 'Pending Issuance',
  POLICY_IN_FORCED: 'Policy In-forced',
  EXPIRED: 'Expired',
  DECLINED: 'Declined',
  DECLINE: 'Decline',
  PENDING_UW_CHECK: 'PendingUWCheck',
};

ObjectUtil.deepFreeze(PROPOSAL_VERSION_STATUS);

export const REGEX = {
  EMAIL: /^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
};
ObjectUtil.deepFreeze(REGEX);

export enum COMPOSITION_TABLE {
  DIRECTORS = 'DIRECTORS',
  COMMISSIONERS = 'COMMISSIONERS',
  SHAREHOLDERS = 'SHAREHOLDERS',
  MANAGEMENT = 'MANAGEMENT',
}
export enum CLIENT_TYPE {
  PT = 'PT',
  CV = 'CV',
}
export enum SIGNED_DOCUMENT {
  SPAK = 'SPAK',
  FINALPROPOSAL = 'Final Proposal',
  KNOWYOURNEED = 'Know Your Need',
  UTMOSTGOODFAITH = 'Utmost Good Faith',
}
export enum YESNO {
  YES = 'Yes',
  NO = 'No',
}

export enum INSURANCE_PRODUCT {
  LI = 'Life Insurance',
  HI = 'Health Insurance',
  PA = 'Personal Accident',
}

export enum ADJUSTMENT_HISTORY_ACTION {
  APPLIED_WITH_PRINT = 'AppliedWithPrint',
  APPLIED_WITHOUT_PRINT = 'AppliedWithoutPrint',
  RETURNED = 'Returned',
  REJECTED = 'Rejected',
  OPEN = 'Open',
}
